module.exports = __webpack_public_path__ + "img/auto-insurance-icon.d8dcbcf8.svg";